export function errorMessage (error) {
  let errMsg = ''
  if (error.response.status === 400) {
    errMsg = error.response.data.Message
  } else if (error.response.status === 500) {
    let hasMessage = 'Message' in error.response.data
    let hasExceptionMessage = 'ExceptionMessage' in error.response.data
    if (hasMessage && hasExceptionMessage) {
      errMsg = `${error.response.data.Message} ${error.response.data.ExceptionMessage}`
    } else if (hasMessage && !hasExceptionMessage) {
      errMsg = error.response.data.Message
    } else if (!hasMessage && hasExceptionMessage) {
      errMsg = error.response.data.ExceptionMessage
    }
  }
  return errMsg
}